var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5059 0H1.49414C0.671965 0 0 0.66901 0 1.49414V10.459C0 11.2844 0.672396 11.9531 1.49414 11.9531H15.5059C16.328 11.9531 17 11.2841 17 10.459V1.49414C17 0.668811 16.3277 0 15.5059 0ZM15.2764 0.996094C14.7934 1.48076 9.11907 7.17353 8.88595 7.40742C8.69125 7.60272 8.30885 7.60285 8.11405 7.40742L1.72357 0.996094H15.2764ZM0.996094 10.2759V1.67726L5.28146 5.97656L0.996094 10.2759ZM1.72357 10.957L5.98466 6.68206L7.40858 8.11063C7.99209 8.69603 9.00814 8.6958 9.59145 8.11063L11.0154 6.6821L15.2764 10.957H1.72357ZM16.0039 10.2759L11.7185 5.97656L16.0039 1.67726V10.2759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMail);
export default __webpack_public_path__ + "static/media/IMail.3eb2d45e82eb13a6ae3e3c3ee4b21a34.svg";
export { ForwardRef as ReactComponent };